var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterFunnelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16646_7624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5304 3.40023C2.5295 2.93352 2.52905 2.70016 2.61954 2.52173C2.69913 2.36477 2.82637 2.23704 2.98301 2.15685C3.1611 2.06568 3.39445 2.06523 3.86116 2.06433L17.8611 2.03738C18.3278 2.03648 18.5612 2.03603 18.7396 2.12651C18.8966 2.20611 19.0243 2.33334 19.1045 2.48999C19.1957 2.66808 19.1961 2.90143 19.197 3.36814L19.1981 3.92597C19.1985 4.14997 19.1988 4.26196 19.1716 4.36616C19.1475 4.4585 19.1077 4.54601 19.054 4.62489C18.9934 4.7139 18.9089 4.78741 18.74 4.93444L13.419 9.56386C13.2501 9.71089 13.1656 9.7844 13.105 9.87341C13.0513 9.95229 13.0115 10.0398 12.9874 10.1321C12.9602 10.2363 12.9605 10.3483 12.9609 10.5723L12.9693 14.9288C12.9696 15.0918 12.9697 15.1732 12.9436 15.2437C12.9205 15.306 12.8828 15.3619 12.8337 15.4067C12.7782 15.4574 12.7026 15.4878 12.5514 15.5486L9.72025 16.6874C9.4142 16.8105 9.26118 16.872 9.13819 16.8467C9.03064 16.8246 8.93618 16.7609 8.87533 16.6695C8.80575 16.565 8.80544 16.4 8.8048 16.0701L8.79423 10.5804C8.7938 10.3564 8.79359 10.2444 8.76601 10.1403C8.74158 10.048 8.70149 9.96066 8.64748 9.88199C8.58653 9.79322 8.50176 9.72003 8.3322 9.57365L2.9935 4.96475C2.82395 4.81837 2.73917 4.74519 2.67823 4.65641C2.62422 4.57774 2.58412 4.49038 2.55969 4.39814C2.53212 4.29405 2.5319 4.18205 2.53147 3.95805L2.5304 3.40023Z",
    stroke: "#F7F9F9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16646_7624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.85791 0.40332) rotate(-0.110297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterFunnelIcon);
export default __webpack_public_path__ + "static/media/filter-funnel-icon.a735588b60211321e364c9893c93fc15.svg";
export { ForwardRef as ReactComponent };